<div class="palette-section mt-2">
  <div class="palette-row">
    @for (tone of palette; track $index) {
      <div
        class="tone-box"
        [style.backgroundColor]="tone.hex"
        [title]="tone.hex"
        [class.original-color]="$index === originalColorIdx"
        >
        {{ tone.tone }}
        @if ($index === originalColorIdx) {
          <span class="original-indicator">★</span>
        }
      </div>
    }
  </div>
</div>
